import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { cubic, quartic } from '@juliendargelos/easings';
import { Container, useTick } from '@pixi/react';
import { useCallback, useEffect, useRef, useState } from 'react';
import { shallowEqual } from 'react-redux';
import { POKER_SEAT_ROUNDED_RECT_RADIUS } from '../../../constants/constants';
import { clearWinChipsAnimation } from '../../../redux/actions/pokerActions';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { WIN_CHIPS_ANIM_COLOR_NUM } from '../../../styles/colors';
import { isTestEnvironment } from '../../../utils/utils';
import { Rect } from '../pixiComponents/rect';
const DURATION_MS = 1000;
export const PlayerChipsAddedAnimationContainer = ({ seatIndex }) => {
    const seatDimensions = useAppSelector((state) => state.gameDimensions.seatDimensions, shallowEqual);
    const startTimestampMs = useAppSelector((state) => state.poker.winChipsAnimations[seatIndex]);
    const [isAnimating, setIsAnimating] = useState(false);
    const rectRef = useRef();
    const dispatch = useAppDispatch();
    const rectRefFn = useCallback((rect) => {
        rectRef.current = rect;
    }, []);
    const animate = useCallback(() => {
        if (!rectRef.current) {
            return;
        }
        if (!seatDimensions) {
            return;
        }
        function endAnimation() {
            dispatch(clearWinChipsAnimation(seatIndex));
            setIsAnimating(false);
        }
        if (startTimestampMs === undefined) {
            endAnimation();
            return;
        }
        const elapsedMs = performance.now() - startTimestampMs;
        if (elapsedMs > DURATION_MS) {
            endAnimation();
            return;
        }
        const ratioDone = elapsedMs / DURATION_MS;
        rectRef.current.y = -cubic.in(ratioDone) * seatDimensions.h;
        rectRef.current.alpha = 1 - quartic.in(ratioDone);
    }, [startTimestampMs, seatDimensions, dispatch, seatIndex]);
    useEffect(() => {
        if (startTimestampMs !== undefined) {
            setIsAnimating(true);
        }
    }, [startTimestampMs]);
    useTick(animate, isAnimating);
    if (seatDimensions === undefined ||
        startTimestampMs === undefined ||
        performance.now() > startTimestampMs + DURATION_MS) {
        return null;
    }
    const { w, h } = seatDimensions;
    const x = -w / 2;
    const y = -h / 2;
    const pixiData = isTestEnvironment() ? { type: 'player-chips-added-animation', seatIndex } : null;
    return (_jsx(Container, { "pixi-data": pixiData, x: x, y: y, interactiveChildren: false, children: _jsx(Rect, { ref: rectRefFn, x: 0, y: 0, w: w, h: h, fillColor: WIN_CHIPS_ANIM_COLOR_NUM, radius: POKER_SEAT_ROUNDED_RECT_RADIUS }) }));
};
